import { render, staticRenderFns } from "./application-add.vue?vue&type=template&id=42396572&"
import script from "./application-add.vue?vue&type=script&lang=js&"
export * from "./application-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42396572')) {
      api.createRecord('42396572', component.options)
    } else {
      api.reload('42396572', component.options)
    }
    module.hot.accept("./application-add.vue?vue&type=template&id=42396572&", function () {
      api.rerender('42396572', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/app-manage/application-manage/application-add.vue"
export default component.exports